<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8WNqw0/tc-custom/9781504086127.jpg?1728155782215" alt="This image is the cover for the book Lines of Deception, The Kaspar Brothers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lines of Deception, The Kaspar Brothers
      </h1>
      <p class="bookDescription body article font2">
        <b>A West German nightclub owner goes behind the Iron Curtain on a desperate mission to save his brother, in this Cold War thriller by the author of <i>Lost Kin</i>.</b><br/><br/><i>West Germany, 1949</i>. Former actor Max Kaspar suffered greatly in the Second World War. Now he owns a nightclub in Munich—and occasionally lends a hand to the newly formed CIA. Meanwhile, his brother Harry has ventured beyond the Iron Curtain to rescue an American scientist. When Harry is also taken captive, Max resolves to locate his brother at all costs. The last thing he expects is for Harry to go rogue.<br/><br/> Max’s treacherous quest takes him to Vienna and Prague to Soviet East Germany and Communist Poland. Along the way, dangerous operators from Harry’s past join the pursuit: his former lover Katarina, who’s working for the Israelis, and former Nazi Hartmut Dietz, now an agent of East German intelligence. But can anyone be trusted? Even the American scientist Stanley Samaras may not be the hero Harry had believed him to be . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steve Anderson
      </h2>
      
      <p class="authorDescription body article"> Steve Anderson&#160;is the author of the Kaspar Brothers novels:&#160;<I>The Losing Role</I>,&#160;<I>Liberated</I>, and&#160;<I>Lost Kin</I>.&#160;<I>Under False Flags&#160;</I>is the prequel to his novel&#160;<I>The Preserve</I>. Anderson was a Fulbright Fellow in Germany and is a literary translator of bestselling German fiction as well as a freelance editor. He lives in Portland, Oregon.&#160; </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28d59414